export default "__VITE_ASSET__k8$AjRrq__"